import type { ComponentPropsWithRef, ReactNode } from 'react'

export interface ScreenOverlayProps extends ComponentPropsWithRef<'div'> {
    opacity?: string
    children?: ReactNode
}

export function ScreenOverlay({
    opacity = 'opacity-60',
    children,
    className = '',
    onClick,
    ...restProps
}: ScreenOverlayProps) {
    return (
        <div
            aria-hidden="true"
            {...restProps}
            className={`fixed inset-0 z-40 ${className}`.trim()}
        >
            <div
                onClick={onClick}
                className={`fixed inset-0 bg-stone-900 ${opacity}`}
            />
            {children ? (
                <div className="fixed inset-0 flex items-center justify-center pointer-events-none">
                    <div className="flex flex-col items-center justify-center pointer-events-auto">
                        {children}
                    </div>
                </div>
            ) : null}
        </div>
    )
}
